import React, { useEffect, useCallback, useRef } from "react";
import Header from "../Header";
import useState from "react-usestateref";
import Footer from "../Footer";
import { useNavigate } from "react-router-dom";
import { actionGetConnectors } from "../../redux/actions/connectorAction";
import {
  actionGetDatasources,
  actionSetOneDatasource,
} from "../../redux/actions/datasourceAction";
import Modal from "../Views/Modal";
import { useSelector, useDispatch } from "react-redux";

import Snackbar from "@mui/material/Snackbar";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import { LoadingOutlined, SyncOutlined } from "@ant-design/icons";
import CustomSelect from "../Views/CustomSelect";
import { useSnackbar } from "notistack";
import { Checkbox } from "antd";
import { Alert } from "@mui/material";
import { isInteger, parseInt, unionBy } from "lodash";
import { Popover } from "@mui/material";
import { Input } from "antd";
import { IoText } from "react-icons/io5";
import { TiSortNumerically } from "react-icons/ti";
import { FcOvertime } from "react-icons/fc";
import { FaPercentage } from "react-icons/fa";
import {
  actionCreateColumnDatasource,
  actionGenerateColumnDatasource,
  actionUpdateColumnDatasource,
} from "../../redux/actions/datasourceAction";
import { truncateText } from "../utils/truncateWords";
import Select from "react-select";
import { Search } from "lucide-react";
import {
  ArrowLeftIcon,
  ArrowRightIcon,
  RefreshCwIcon,
  PencilIcon,
  TrashIcon,
} from "lucide-react";
import { ChevronDownIcon } from "lucide-react";
import TableRowLoader from "../Views/TableLoading";

const _ = require("lodash");

const xlsxHost = "https://xlsx.viabber.com";

export default function Columns({ source }) {
  const { TextArea } = Input;
  const datasources = useSelector((state) => state.datasource.datasources);
  const datasource = datasources.find(
    (i) => i.iddatasource === source.iddatasource
  );

  const [columns, setColumns] = useState(
    datasource.columns.map((t) => ({ ...t, generated: false }))
  );
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();

  const idUser = useSelector((state) => state.user.id);
  const token = useSelector((state) => state.user.token);
  const [columnsM, setColumnsM] = useState(
    datasource.columns.map((item) => ({
      type: item.dataType,
      name: item.name.toLocaleLowerCase(),
    }))
  );
  const [isUpdate, setIsUpdate] = useState(false);
  const [visibility, setVisibility] = useState(false);
  const [isFormulaValid, setIsFormulaValid] = useState(null);
  const [formule, setFormule] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [libelle, setLibelle] = useState("");
  const [systemName, setSystemName] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorName, setErrorName] = useState("");
  const [isErrorName, setIsErrorName] = useState(false);
  const [idColumn, setIdColumn] = useState("");
  const [filter, setFilter] = useState("");
  const open = Boolean(anchorEl);
  const optionsType = [
    { label: "Nombre", value: 1 },
    { label: "String", value: 2 },
    { label: "Date", value: 3 },
    { label: "Pourcentage", value: 4 },
  ];
  const [isloading, setIsLoading] = useState(false);
  const [type, setType] = useState(optionsType[0].value);
  const variableNameRegex =
    /^(?!\b(?:abstract|await|boolean|break|byte|case|catch|char|class|const|continue|debugger|default|delete|do|double|else|enum|export|extends|false|final|finally|float|for|function|goto|if|implements|import|in|instanceof|int|interface|long|native|new|null|package|private|protected|public|return|short|static|super|switch|synchronized|this|throw|throws|transient|true|try|typeof|var|void|volatile|while|with|yield)\b)[A-Za-z_$][A-Za-z0-9_$]*$/;

  function isValidVariableName(name) {
    return variableNameRegex.test(name);
  }

  useEffect(() => {
    setColumns(datasource.columns.map((t) => ({ ...t, generated: false })));
  }, [datasources]);

  const formulaValidator = (formula, columns) => {
    const intitialisations = columns.map((item) => {
      if (item.type == 1 && item.type == 4) return `var ${item.name} = 1;`;
      else if (item.type == 2) return `var ${item.name} = "a";`;
      else if (item.type == 3) return `var _${item.name} = new Date();`;
      else return `var ${item.name} = 1;`;
    });

    try {
      const dynamicInitializations = columns.map((item) => {
        if (item.type == 1 && item.type == 4) return `var ${item.name} = 1;`;
        else if (item.type == 2) return `var ${item.name} = "a";`;
        else if (item.type == 3) return `var ${item.name} = new Date();`;
        else return `var ${item.name} = 1;`;
      });
      // console.log(columns, dynamicInitializations);
      // eslint-disable-next-line no-eval
      const result = eval(
        `
        ${intitialisations.join(" ")} ${dynamicInitializations.join(
          " "
        )} ${formula} `
      );
      const typeResult = [1, 4].includes(type)
        ? "number"
        : type === 2
        ? "string"
        : "object";
      if (typeof result === typeResult) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  };

  const handleFormulaChange = (event) => {
    const enteredFormula = event.target.value;

    if (enteredFormula.includes("#")) {
      setAnchorEl(event.currentTarget);
    } else {
      let updatedFormula = enteredFormula;
      try {
        setFormule(updatedFormula);
      } catch (error) {}
    }
  };

  const cancel = () => {
    setVisibility(false);
    setFormule("");
    setLibelle("");
    setSystemName("");
    setType(optionsType[0].value);
    setIsFormulaValid(null);
    setIsUpdate(false);
    setErrorName("");
    setIsErrorName(false);
    setIdColumn("");
    setLoading(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCurrentGoalCol = (column) => {
    setFormule((prevFormula) => prevFormula + `${column}`);
    setAnchorEl(null);
  };

  const submit = (e) => {
    e.preventDefault();
    if (isErrorName) {
      enqueueSnackbar("Le nom système n'est pas valide", {
        variant: "warning",
      });
      return;
    }
    //  else if (!isFormulaValid) {
    //   enqueueSnackbar("Votre formule n'est pas valide", {
    //     variant: "warning",
    //   });
    //   return;
    // }
    else if (libelle && systemName && formule && type) {
      setLoading(true);

      if (!isUpdate) {
        add();
      } else {
        edit();
      }
    } else {
      enqueueSnackbar("Tous les champs sont obligatoires", {
        variant: "warning",
      });
    }
  };

  const add = () => {
    // if (!isFormulaValid) {
    //   enqueueSnackbar("Votre formule n'est pas valide", {
    //     variant: "warning",
    //   });
    //   return;
    // }
    dispatch(
      actionCreateColumnDatasource(
        token,
        datasource.iddatasource,
        systemName,
        formule,
        [1, 4].includes(+type) ? "indicator" : "dimension",
        type,
        libelle,

        (status) => {
          if (status) {
            setLoading(false);
            enqueueSnackbar("La colonne a été créée avec succès", {
              variant: "success",
            });
            cancel();
          } else {
            setLoading(false);
            enqueueSnackbar("Erreur lors de la création de la colonne", {
              variant: "error",
            });
          }
        }
      )
    );
  };

  const edit = () => {
    dispatch(
      actionUpdateColumnDatasource(
        idColumn,
        token,
        datasource.iddatasource,
        systemName,
        formule,
        [1, 4].includes(+type) ? "indicator" : "dimension",
        type,
        libelle,
        (status) => {
          if (status) {
            setLoading(false);
            enqueueSnackbar("La colonne a été mise à jour avec succès", {
              variant: "success",
            });
            cancel();
          } else {
            setLoading(false);
            enqueueSnackbar("Erreur lors de la mise à jour de la colonne", {
              variant: "error",
            });
          }
        }
      )
    );
  };

  const generateColummn = (idcolumn) => {
    dispatch(
      actionGenerateColumnDatasource(idcolumn, token, (status) => {
        if (status) {
          enqueueSnackbar("Insertion réalisée avec succès", {
            variant: "success",
          });
          setColumns((items) =>
            items.map((item) => {
              item.generated = false;
              return item;
            })
          );
        } else {
          enqueueSnackbar("Erreur lors de l'insertion des données", {
            variant: "error",
          });
          setColumns((items) =>
            items.map((item) => {
              item.generated = false;
              return item;
            })
          );
        }
      })
    );
  };

  useEffect(() => {
    if (systemName && !isUpdate) {
      if (columns.find((item) => item.name === systemName)) {
        setErrorName("Ce nom système est déjà utilisé.");
        setIsErrorName(true);
      } else if (!isValidVariableName(systemName)) {
        setErrorName("le nom système n'est pas valide.");

        setIsErrorName(true);
      } else {
        setErrorName("");
        setIsErrorName(false);
      }
    }
  }, [systemName]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: " #fff", // bg-red-600
      border: "none",
      boxShadow: "none",
      outline: "none",
      padding: "0",
      fontWeight: "600",
      fontFamily: "Poppins",
      fontSize: "18px", // tailwind equivalent of small font
      minHeight: "auto",
      minWidth: "150px",
      cursor: "pointer",
      padding: 0,
      margin: 0,
      marginTop: 10,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "5px",
      fontSize: "12px",
      fontWeight: "600",
      fontFamily: "Poppins", // tailwind equivalent of small font
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      // color: "#ffffff", fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "18px", // tailwind equivalent of small font
    }),
    singleValue: (provided) => ({
      ...provided,
      // color: "#ffffff", // text color inside the select fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "18px", // tailwind equivalent of small font
    }),
  };

  const customStylesVue = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: "#fff", // bg-red-600
      border: "none",
      boxShadow: "none",
      outline: "none",
      padding: "0",
      fontWeight: "500",
      fontFamily: "Poppins",
      fontSize: "16 px", // tailwind equivalent of small font
      minHeight: "20px",
      minWidth: "130px",
      cursor: "pointer",
      padding: 0,
      margin: 0,
      width: 320,
    }),
    option: (provided, state) => ({
      ...provided,
      padding: "5px",
      fontSize: "12px",
      fontWeight: "500",
      fontFamily: "Poppins", // tailwind equivalent of small font
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      fontFamily: "Poppins",
      fontSize: "15px", // tailwind equivalent of small font
    }),
    singleValue: (provided) => ({
      ...provided, // text color inside the select fontWeight: "bold",
      fontFamily: "Poppins",
      fontSize: "15px", // tailwind equivalent of small font
    }),
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const containerRef = useRef(null);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = columns.filter((elt) => {
    if (filter === "") {
      return elt;
    }
    return elt.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
  });

  const totalPages = Math.ceil(
    columns.filter((elt) => {
      if (filter === "") {
        return elt;
      }
      return elt.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase());
    }).length / itemsPerPage
  );

  const isAdd = useSelector((state) => state.datasource.isAdd);
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const getVisiblePageNumbers = useCallback(() => {
    const maxVisiblePages = 5; // Nombre maximum de pages visibles
    const halfVisible = Math.floor(maxVisiblePages / 2);

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= halfVisible + 1) {
      return [
        ...Array.from({ length: maxVisiblePages - 1 }, (_, i) => i + 1),
        -1,
        totalPages,
      ];
    }

    if (currentPage >= totalPages - halfVisible) {
      return [
        1,
        -1,
        ...Array.from(
          { length: maxVisiblePages - 1 },
          (_, i) => totalPages - maxVisiblePages + 2 + i
        ),
      ];
    }

    return [
      1,
      -1,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      -1,
      totalPages,
    ];
  }, [currentPage, totalPages]);

  return (
    <div className="h-full">
      <Modal
        visible={visibility}
        title={isUpdate ? "Modifier une colonne" : "Ajouter une colonne"}
        onCancel={cancel}
        large={false}
      >
        <form onSubmit={submit} className="flex flex-col w-full h-full gap-4 ">
          <div className="flex flex-col gap-2">
            <label for="nom" className="font-poppins font-[400px]">
              Entrer le libellé
            </label>

            <input
              className="w-full p-2 border-2 rounded-md outline-none border-inputBorderColor"
              id="nom"
              type="text"
              value={libelle}
              onChange={(e) => setLibelle(e.target.value)}
              placeholder="Obligatoire"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label for="nom" className="font-poppins font-[400px]">
              Entrer le Nom système
            </label>

            <input
              className="w-full p-2 border-2 rounded-md outline-none border-inputBorderColor"
              id="nom"
              type="text"
              value={systemName}
              onChange={(e) => setSystemName(e.target.value)}
              placeholder="Obligatoire"
              required
              disabled={isUpdate}
            />

            {isErrorName && !isUpdate && (
              <div className="absolute mt-1 text-red-500">{errorName}</div>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <label for="operation" className="font-poppins font-[400px]">
              Type de la donnée
            </label>

            <div className="relative">
              <select
                id="operation"
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="block w-full p-2 py-2 pl-3 pr-10 text-base bg-white border-2 rounded-md outline-none appearance-none cursor-pointer border-inputBorderColor focus:outline-none focus:ring-"
              >
                <option value="" disabled>
                  Sélectionner le type
                </option>
                {optionsType.map((type) => (
                  <option key={type.value} value={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none">
                <ChevronDownIcon className="w-4 h-4" />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-2">
            <label for="metric" className="font-poppins font-[400px]">
              Formule (saisir # pour afficher les colonnes de de la source de
              donnée.)
            </label>

            <textarea
              style={{ minHeight: 100 }}
              id="textArea"
              type="text"
              value={formule}
              onChange={handleFormulaChange}
              className="block w-full h-[150px] resize-none border border-gray-300 rounded-md py-2 px-3 text-base focus:ring-1  focus:outline-none placeholder-gray-400 font-poppins placeholder:font-poppins"
              placeholder="Entrez votre formule ici..."
            />
            {/* {isFormulaValid === false && (
              <div className="mt-1 text-red-500 font-poppins">
                La formule n'est pas valide.
              </div>
            )}
            {isFormulaValid === true && (
              <div className="mt-1 text-green-500 font-poppins">
                La formule est valide.
              </div>
            )} */}
            <Popover
              // id={id}
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "center",
              }}
            >
              <div className="mui-popover-custom">
                <ul className="grid items-center content-center grid-cols-1 gap-2">
                  {columnsM &&
                    columnsM
                      .filter((item) => {
                        if (isUpdate) {
                          return item.name !== systemName;
                        }
                        return true;
                      })
                      .map((column, index) => (
                        <li
                          key={index}
                          className="transition-all duration-300 hover:cursor-pointer hover:bg-[#05BAF3] hover:text-white opacity-45 bg-[#E3E3E3] rounded-lg text-center"
                          onClick={() => handleCurrentGoalCol(column.name)}
                        >
                          {column.name}
                        </li>
                      ))}
                </ul>
              </div>
            </Popover>
          </div>
          <div className="flex items-center justify-center gap-4 mt-">
            <button
              className="btn-border close-btn-submit"
              type="reset"
              onClick={cancel}
            >
              Annuler
            </button>
            <button className="btn-full" type="submit" disabled={loading}>
              {loading
                ? isUpdate
                  ? "Modifier..."
                  : "Ajouter..."
                : isUpdate
                ? "Modifier"
                : "+ Ajouter"}
            </button>
          </div>
        </form>
      </Modal>

      <main className="w-full h-full mx-auto ">
        <>
          <div className="px-2 mb-3 w-full row actions-nav mx-auto border-r-black rounded-[20px]  items-center gap-2">
            <div className="flex items-center justify-between w-full gap-2 font-poppins ">
              <div className="flex items-center gap-2 text-[12px] m-0 p-0 justify-center ml-1">
                <div className="relative flex items-center ">
                  <Search className="absolute w-5 h-5 text-gray-400 transform -translate-y-1/2 left-3 top-1/2" />
                  <input
                    type="text"
                    placeholder="Recherche"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    className="w-full py-2 pl-10 pr-4 text-gray-700 border-2 border-gray-250 bg-white rounded-[10px] outline-none  focus:bg-white"
                  />
                </div>
              </div>

              <div className="flex items-center gap-2">
                <p
                  className="hover:text-white hover:bg-colorText border-2 border-colorText text-colorText  rounded-[5px] p-0 m-0 text-center font-poppins py-1 w-[180px] font-semibold cursor-pointer text-[12px]"
                  onClick={() => {
                    setVisibility(true);
                    setIsUpdate(false);
                  }}
                  type="submit"
                >
                  +Ajouter une colonne
                </p>
              </div>
            </div>
          </div>

          {/* <div className="bloc-fond-fonce2 wrap-table"> */}
          <div className="w-full px-3 bg-customBg h-[83vh] mb-8 rounded-xl">
            <table className="w-full bg-white shadow-sm ">
              <thead className="mb-[600px] font-poppins leading-[50px] ">
                <tr className="bg-white rounded-xl">
                  <th className="p-1 pl-2 font-semibold text-left text-black border-b text-[12px] rounded-xl">
                    Libellé
                  </th>
                  <th className="p-[3px] font-semibold text-left text-black border-b text-[12px]">
                    Nom Système
                  </th>
                  <th className="p-[3px] font-semibold text-left text-black border-b text-[12px]">
                    Type de donnée
                  </th>

                  <th className="p-[3px] font-semibold text-left text-black border-b text-[12px]">
                    Type de colonne
                  </th>

                  <th className="p-[3px] font-semibold text-center text-black border-b text-[12px]">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="text-[12px] mt-[900px] border-t-8 border-customBg overflow-y-auto">
                {isloading
                  ? [...Array(5)].map((_, index) => (
                      <tr
                        key={index}
                        className="border-b hover:bg-gray-50 font-poppins text-[15px] text-black  h-10  cursor-pointer font-semibold"
                      >
                        <td colSpan={6}>
                          <TableRowLoader />
                        </td>
                      </tr>
                    ))
                  : currentItems?.map((elt) => {
                      return (
                        <tr
                          id={elt.idcolumn}
                          key={elt.idcolumn}
                          className="border-b hover:bg-gray-50 font-poppins text-[15px] text-black  h-[40px]  cursor-pointer font-[400px]"
                        >
                          <td className="p-0 pl-2 text-[12px] text-black font-[500px]">
                            {truncateText(elt.libelle ? elt.libelle : elt.name)}
                          </td>
                          <td className="p-0 text-[12px] text-black font-[400px]">
                            {truncateText(elt.name)}
                          </td>
                          <td className=" text-left text-black font-[400px]">
                            {elt.dataType == 1 && (
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.69238 15.3463V10.8463H4.19238V9.65381H6.88463V15.3463H5.69238ZM9.13488 15.3463V12.9423C9.13488 12.6916 9.21963 12.4816 9.38913 12.3121C9.55863 12.1426 9.76872 12.0578 10.0194 12.0578H12.1539V10.8463H9.13488V9.65381H12.4616C12.7123 9.65381 12.9224 9.73864 13.0919 9.90831C13.2615 10.0778 13.3464 10.2879 13.3464 10.5386V12.0578C13.3464 12.3085 13.2615 12.5186 13.0919 12.6881C12.9224 12.8576 12.7123 12.9423 12.4616 12.9423H10.3271V14.1538H13.3464V15.3463H9.13488ZM15.0964 15.3463V14.1538H18.1156V12.9423H16.0964V12.0578H18.1156V10.8463H15.0964V9.65381H18.4231C18.6738 9.65381 18.8839 9.73864 19.0534 9.90831C19.2231 10.0778 19.3079 10.2879 19.3079 10.5386V14.4616C19.3079 14.7122 19.2231 14.9223 19.0534 15.0918C18.8839 15.2615 18.6738 15.3463 18.4231 15.3463H15.0964Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                            {elt.dataType == 2 && (
                              <svg
                                width="24"
                                height="25"
                                viewBox="0 0 24 25"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.44238 20.0576V7.05764H2.44238V4.94214H14.5579V7.05764H9.55788V20.0576H7.44238ZM16.4424 20.0576V12.0576H13.4424V9.94214H21.5579V12.0576H18.5579V20.0576H16.4424Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                            {elt.dataType == 3 && (
                              <svg
                                width="17"
                                height="21"
                                viewBox="0 0 17 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.80775 20.0576C1.30258 20.0576 0.875 19.8826 0.525 19.5326C0.175 19.1826 0 18.755 0 18.2499V4.86538C0 4.36022 0.175 3.93263 0.525 3.58263C0.875 3.23263 1.30258 3.05763 1.80775 3.05763H3.19225V0.942383H4.73075V3.05763H12.3077V0.942383H13.8077V3.05763H15.1923C15.6974 3.05763 16.125 3.23263 16.475 3.58263C16.825 3.93263 17 4.36022 17 4.86538V18.2499C17 18.755 16.825 19.1826 16.475 19.5326C16.125 19.8826 15.6974 20.0576 15.1923 20.0576H1.80775ZM1.80775 18.5576H15.1923C15.2692 18.5576 15.3398 18.5256 15.4038 18.4614C15.4679 18.3974 15.5 18.3269 15.5 18.2499V8.86538H1.5V18.2499C1.5 18.3269 1.53208 18.3974 1.59625 18.4614C1.66025 18.5256 1.73075 18.5576 1.80775 18.5576ZM1.5 7.36538H15.5V4.86538C15.5 4.78838 15.4679 4.71788 15.4038 4.65388C15.3398 4.58972 15.2692 4.55763 15.1923 4.55763H1.80775C1.73075 4.55763 1.66025 4.58972 1.59625 4.65388C1.53208 4.71788 1.5 4.78838 1.5 4.86538V7.36538ZM8.5 12.6346C8.25517 12.6346 8.0465 12.5484 7.874 12.3759C7.70167 12.2035 7.6155 11.9949 7.6155 11.7499C7.6155 11.505 7.70167 11.2964 7.874 11.1239C8.0465 10.9515 8.25517 10.8654 8.5 10.8654C8.74483 10.8654 8.9535 10.9515 9.126 11.1239C9.29833 11.2964 9.3845 11.505 9.3845 11.7499C9.3845 11.9949 9.29833 12.2035 9.126 12.3759C8.9535 12.5484 8.74483 12.6346 8.5 12.6346ZM4.5 12.6346C4.25517 12.6346 4.0465 12.5484 3.874 12.3759C3.70167 12.2035 3.6155 11.9949 3.6155 11.7499C3.6155 11.505 3.70167 11.2964 3.874 11.1239C4.0465 10.9515 4.25517 10.8654 4.5 10.8654C4.74483 10.8654 4.9535 10.9515 5.126 11.1239C5.29833 11.2964 5.3845 11.505 5.3845 11.7499C5.3845 11.9949 5.29833 12.2035 5.126 12.3759C4.9535 12.5484 4.74483 12.6346 4.5 12.6346ZM12.5 12.6346C12.2552 12.6346 12.0465 12.5484 11.874 12.3759C11.7017 12.2035 11.6155 11.9949 11.6155 11.7499C11.6155 11.505 11.7017 11.2964 11.874 11.1239C12.0465 10.9515 12.2552 10.8654 12.5 10.8654C12.7448 10.8654 12.9535 10.9515 13.126 11.1239C13.2983 11.2964 13.3845 11.505 13.3845 11.7499C13.3845 11.9949 13.2983 12.2035 13.126 12.3759C12.9535 12.5484 12.7448 12.6346 12.5 12.6346ZM8.5 16.5576C8.25517 16.5576 8.0465 16.4714 7.874 16.2989C7.70167 16.1265 7.6155 15.918 7.6155 15.6731C7.6155 15.4281 7.70167 15.2195 7.874 15.0471C8.0465 14.8746 8.25517 14.7884 8.5 14.7884C8.74483 14.7884 8.9535 14.8746 9.126 15.0471C9.29833 15.2195 9.3845 15.4281 9.3845 15.6731C9.3845 15.918 9.29833 16.1265 9.126 16.2989C8.9535 16.4714 8.74483 16.5576 8.5 16.5576ZM4.5 16.5576C4.25517 16.5576 4.0465 16.4714 3.874 16.2989C3.70167 16.1265 3.6155 15.918 3.6155 15.6731C3.6155 15.4281 3.70167 15.2195 3.874 15.0471C4.0465 14.8746 4.25517 14.7884 4.5 14.7884C4.74483 14.7884 4.9535 14.8746 5.126 15.0471C5.29833 15.2195 5.3845 15.4281 5.3845 15.6731C5.3845 15.918 5.29833 16.1265 5.126 16.2989C4.9535 16.4714 4.74483 16.5576 4.5 16.5576ZM12.5 16.5576C12.2552 16.5576 12.0465 16.4714 11.874 16.2989C11.7017 16.1265 11.6155 15.918 11.6155 15.6731C11.6155 15.4281 11.7017 15.2195 11.874 15.0471C12.0465 14.8746 12.2552 14.7884 12.5 14.7884C12.7448 14.7884 12.9535 14.8746 13.126 15.0471C13.2983 15.2195 13.3845 15.4281 13.3845 15.6731C13.3845 15.918 13.2983 16.1265 13.126 16.2989C12.9535 16.4714 12.7448 16.5576 12.5 16.5576Z"
                                  fill="black"
                                />
                              </svg>
                            )}
                            {elt.dataType == 4 && <FaPercentage size={20} />}
                          </td>
                          <td className=" text-left text-black font-[400px]">
                            {elt.columnType}
                          </td>

                          <td className="p-0 text-[12px]">
                            <div className="flex justify-center gap-3 items-left">
                              <button
                                className={`text-gray-600 ${
                                  elt.isExtension ? "hover:text-gray-900" : ""
                                } disabled:opacity-50 focus:outline-none`}
                                onClick={() => {
                                  if (elt.isExtension) {
                                    setColumns((items) =>
                                      items.map((item) => {
                                        if (+item.idcolumn === +elt.idcolumn) {
                                          item.generated = true;
                                        }
                                        return item;
                                      })
                                    );
                                    generateColummn(elt.idcolumn);
                                  }
                                }}
                                disabled={!elt.isExtension}
                              >
                                <RefreshCwIcon
                                  className={`h-5 w-5 ${
                                    elt.generated ? "animate-spin" : ""
                                  }`}
                                />
                              </button>
                              <button
                                className={`text-gray-600 ${
                                  elt.isExtension ? "hover:text-gray-900" : ""
                                } disabled:opacity-70 focus:outline-none`}
                                onClick={() => {
                                  if (elt.isExtension) {
                                    setIdColumn(elt.idcolumn);
                                    setVisibility(true);
                                    setIsUpdate(true);
                                    setLibelle(
                                      elt.libelle ? elt.libelle : elt.name
                                    );
                                    setSystemName(elt.name);
                                    setFormule(elt.formula);
                                    setType(
                                      optionsType.find(
                                        (item) => item.value === +elt.dataType
                                      ).value
                                    );
                                  }
                                }}
                                disabled={!elt.isExtension}
                              >
                                <PencilIcon className="w-5 h-5" />
                              </button>
                              <button
                                className={`text-gray-600 ${
                                  elt.isExtension ? "hover:text-gray-900" : ""
                                } disabled:opacity-50 focus:outline-none`}
                                disabled={!elt.isExtension}
                              >
                                <TrashIcon className="w-5 h-5" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
              </tbody>
            </table>
            {/* {totalPages > 1 && (
              <div className="flex justify-center mt-[10px] items-center gap-[10px] flex-wrap">
                <div
                  onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="cursor-pointer "
                  aria-label="Page précédente"
                >
                  &#8592;
                </div>
                {getVisiblePageNumbers().map((page, index) =>
                  page === -1 ? (
                    <span
                      key={`ellipsis-${index}`}
                      className="pagination-ellipsis"
                    >
                      ...
                    </span>
                  ) : (
                    <div
                      key={page}
                      onClick={() => handlePageChange(page)}
                      className={`p-[8px] pt-[4px] pb-[4px] rounded-[8px] font-poppins cursor-pointer w-[30px] text-center ${
                        currentPage === page
                          ? "bg-colorText  text-white "
                          : "text-gray"
                      }`}
                    >
                      {page}
                    </div>
                  )
                )}
                <div
                  onClick={() =>
                    handlePageChange(Math.min(totalPages, currentPage + 1))
                  }
                  disabled={currentPage === totalPages}
                  className=""
                  aria-label="Page suivante"
                >
                  &#8594;
                </div>
              </div>
            )} */}
          </div>
          {/* </div> */}
        </>
      </main>
      {/* <Footer /> */}
    </div>
  );
}
